import { Link } from 'react-router-dom';
// material-ui
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, useMediaQuery, Box } from '@mui/material';

// project imports
import AuthForgotPassword from '../auth-forms/AuthForgotPassword';

// ================================|| AUTH3 - FORGOT PASSWORD ||================================ //

const ForgotPassword = () => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid container sx={{ minHeight: '100vh', backgroundColor: '#fff' }}>
      {/* LADO IZQUIERDO - IMAGEN Y TEXTO DE BIENVENIDA */}
      {!matchDownMD && (
        <Grid
          item
          xs={12}
          md={6}
          lg={7}
          sx={{
            position: 'relative',
            backgroundImage: 'url("https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2070&auto=format&fit=crop")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            p: { md: 6, lg: 8 },
            color: '#fff',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.65)',
              zIndex: 1
            }
          }}
        >
          {/* Texto Principal */}
          <Box sx={{ position: 'relative', zIndex: 2, flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Typography
              variant="h1"
              sx={{
                fontWeight: 700,
                mb: 2,
                color: '#fff',
                fontSize: { md: '3rem', lg: '4rem' },
                lineHeight: 1.2
              }}
            >
              Bienvenido a<br />SegoCloud
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 400,
                maxWidth: '500px',
                lineHeight: 1.6,
                color: 'rgba(255,255,255,0.85)'
              }}
            >
              El futuro de la gestión hotelera, combinando el servicio clásico con la tecnología moderna.
            </Typography>
          </Box>

          {/* Footer del lado izquierdo */}
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Typography variant="subtitle2" sx={{ fontStyle: 'italic', color: 'rgba(255,255,255,0.6)' }}>
              Redefiniendo la excelencia en la experiencia del huésped.
            </Typography>
          </Box>
        </Grid>
      )}

      {/* LADO DERECHO - FORMULARIO DE RECUPERACIÓN */}
      <Grid
        item
        xs={12}
        md={6}
        lg={5}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#fff'
        }}
      >
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 3, sm: 6, md: 8 } }}>
          <Box sx={{ width: '100%', maxWidth: '450px' }}>
            <Box sx={{ mb: 5 }}>
              <Typography variant="h2" sx={{ fontWeight: 700, color: theme.palette.grey[900], mb: 1.5, fontSize: '2rem' }}>
                Recuperar Contraseña
              </Typography>
              <Typography variant="body1" sx={{ color: theme.palette.grey[600], fontSize: '1rem' }}>
                Restablecer Acceso
              </Typography>
            </Box>

            <AuthForgotPassword />

            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Typography variant="body2" sx={{ color: theme.palette.grey[600] }}>
                ¿Recordaste tu contraseña?{' '}
                <Typography
                  component={Link}
                  to="/login"
                  variant="subtitle2"
                  sx={{
                    textDecoration: 'none',
                    color: theme.palette.primary.main,
                    fontWeight: 600,
                    '&:hover': {
                      color: theme.palette.primary.dark,
                      textDecoration: 'underline'
                    }
                  }}
                >
                  Volver al Inicio de Sesión
                </Typography>
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Footer del lado derecho */}
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="caption" sx={{ color: theme.palette.grey[500] }}>
            © {new Date().getFullYear()} SegoCloud Systems. Todos los derechos reservados. Edición Profesional PMS.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
